import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Globals } from '../globalfunctions.js';
import roleManager from '../utils/roleManager';

const ProtectedRoute = ({ children, requiredPermissions = [], allowedRoles = [] }) => {
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('accessToken');
      if (!token && !Globals.LoginTime) {
        setIsCheckingAuth(false);
        return;
      }
      
      if (Globals.LoginTime) {
        setIsCheckingAuth(false);
        return;
      }
      
      setTimeout(() => {
        setIsCheckingAuth(false);
      }, 100);
    };

    checkAuth();
  }, []);

  if (isCheckingAuth) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f8f9fa'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            fontSize: '24px', 
            marginBottom: '10px' 
          }}>🔐</div>
          <div>Checking authentication...</div>
        </div>
      </div>
    );
  }

  // Check if user is logged in
  if (!Globals.LoginTime) {
    // Store the intended URL for redirect after login
    console.log('ProtectedRoute: User not logged in, storing redirect URL:', window.location.pathname);
    localStorage.setItem('redirectAfterLogin', window.location.pathname);
    return <Navigate to="/login" replace />;
  }

  // Check role-based access if specified
  if (allowedRoles.length > 0) {
    const userRole = roleManager.getCurrentUserRole();
    console.log("User Role:", userRole);
    console.log("Allowed Roles:", allowedRoles);
    if (!allowedRoles.includes(userRole)) {
      return (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          flexDirection: 'column',
          backgroundColor: '#f8f9fa'
        }}>
          <div style={{ 
            backgroundColor: 'white', 
            padding: '40px', 
            borderRadius: '8px', 
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            textAlign: 'center',
            maxWidth: '400px'
          }}>
            <i className="fas fa-lock" style={{ fontSize: '48px', color: '#dc3545', marginBottom: '20px' }}></i>
            <h2 style={{ color: '#dc3545', marginBottom: '10px' }}>Access Denied</h2>
            <p style={{ color: '#666', marginBottom: '20px' }}>
              You don't have permission to access this page.
            </p>
            <p style={{ fontSize: '14px', color: '#888' }}>
              Your role: <strong>{userRole}</strong><br />
              Required roles: <strong>{allowedRoles.join(', ')}</strong>
            </p>
            <button 
              onClick={() => window.history.back()}
              style={{ 
                padding: '10px 20px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                marginTop: '20px'
              }}
            >
              Go Back
            </button>
          </div>
        </div>
      );
    }
  }

  // Check permission-based access if specified
  if (requiredPermissions.length > 0) {
    const hasPermission = roleManager.hasAnyPermission(requiredPermissions);
    if (!hasPermission) {
      return (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          flexDirection: 'column',
          backgroundColor: '#f8f9fa'
        }}>
          <div style={{ 
            backgroundColor: 'white', 
            padding: '40px', 
            borderRadius: '8px', 
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            textAlign: 'center',
            maxWidth: '400px'
          }}>
            <i className="fas fa-shield-alt" style={{ fontSize: '48px', color: '#dc3545', marginBottom: '20px' }}></i>
            <h2 style={{ color: '#dc3545', marginBottom: '10px' }}>Insufficient Permissions</h2>
            <p style={{ color: '#666', marginBottom: '20px' }}>
              You don't have the required permissions to access this page.
            </p>
            <p style={{ fontSize: '14px', color: '#888' }}>
              Required permissions: <strong>{requiredPermissions.join(', ')}</strong>
            </p>
            <button 
              onClick={() => window.history.back()}
              style={{ 
                padding: '10px 20px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                marginTop: '20px'
              }}
            >
              Go Back
            </button>
          </div>
        </div>
      );
    }
  }

  // If all checks pass, render the protected component
  return children;
};

export default ProtectedRoute;